import { Component, OnInit } from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-common-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements OnInit {
  wait: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  showWait() {
    if(!this.wait) {
      this.wait = true;
    }
  }

  hideWait() {
    window.setTimeout(() => {
      if(this.wait) {
        this.wait = false;
      }
    });    
  }
}
